import React, { useContext } from 'react'

const bookingsContext = React.createContext()

const useBookings = () => {
    const context = useContext(bookingsContext)
    if (!context) {
        throw new Error(`UseBookings must be used within an BookingsProvider.`)
    }

    return context
}

const BookingsProvider = ({ data, ...props }) => {
    return <bookingsContext.Provider value={data} {...props} />
}

export { BookingsProvider, useBookings }